import axios from 'axios';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';

let interceptorRegistered = false;

// Global handling for expired/invalid auth: without this, a 401/403 on an
// authenticated request was caught per-call and just shown as a generic
// toast, leaving the user stuck on the same page with a stale token instead
// of being sent back to /login.
export default function setupAuthInterceptor(router) {
  if (interceptorRegistered) return;
  interceptorRegistered = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const requestHeaders = error?.config?.headers || {};
      const hadAuthHeader = Boolean(requestHeaders.Authorization || requestHeaders.authorization);

      if ((status === 401 || status === 403) && hadAuthHeader) {
        const currentPath = window.location.pathname !== '/login' ? window.location.pathname + window.location.search : null;

        localStorage.removeItem('auth-token');
        Cookies.remove('isLoggedIn');
        delete axios.defaults.headers.common['authorization'];

        if (window.location.pathname !== '/login') {
          if (currentPath) {
            localStorage.setItem('redirectTo', currentPath);
          }
          toast.error('Your session has expired. Please log in again.');
          router.push('/login');
        }
      }

      return Promise.reject(error);
    }
  );
}
